import AdminContext from "@logic/AdminContext";
import FeatureFlagRepo, { CustomerFeatureFlags } from "@logic/FeatureFlagRepo";

// Simple in-memory cache of feature flags per customerId
const customerIdToFlagsCache = new Map<string, CustomerFeatureFlags>();

const FeatureFlagCache = {
  // Returns true if the flag is enabled for the current customer
  async GetFeature(key: string): Promise<boolean> {
    const customerId = AdminContext.getCommunityIdInContext();
    if (!customerId) return false;

    let flags = customerIdToFlagsCache.get(customerId);
    if (!flags) {
      flags = await FeatureFlagRepo.getCustomerFlags(customerId);
      customerIdToFlagsCache.set(customerId, flags);
    }
    return flags?.[key] === true;
  },

  // Optional: allow manual refresh for a customer
  async Refresh(customerId?: string): Promise<void> {
    const id = customerId ?? AdminContext.getCommunityIdInContext();
    if (!id) return;
    const flags = await FeatureFlagRepo.getCustomerFlags(id);
    customerIdToFlagsCache.set(id, flags);
  },

  // Optional: clear cache for a customer
  Clear(customerId?: string) {
    const id = customerId ?? AdminContext.getCommunityIdInContext();
    if (!id) return;
    customerIdToFlagsCache.delete(id);
  },
};

export default FeatureFlagCache;
